import { useMemo } from 'react'

import { useLocale } from 'src/contexts/LocaleContext'
import sanitySiteSettings from 'src/data/_static/settings.json'

import type { SanitySettings } from 'src/types/HomepageContent'

export const useSettings = (): SanitySettings => {
  const { language } = useLocale()
  return useMemo(() => sanitySiteSettings[language], [language])
}
